export var PreferenceOverrideSourceEnum;
(function (PreferenceOverrideSourceEnum) {
    PreferenceOverrideSourceEnum["SUBSCRIBER"] = "subscriber";
    PreferenceOverrideSourceEnum["TEMPLATE"] = "template";
})(PreferenceOverrideSourceEnum || (PreferenceOverrideSourceEnum = {}));
